import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-info-card',
    templateUrl: './info-card.component.html',
    styleUrls: ['./info-card.component.css'],
    standalone: true,
    imports: [],
})
export class InfoCardComponent {
    @Input() message: string = '';
}
